import axios from 'axios'

export default {
  login (params, callback, errorCallback) {
    axios.post(process.env.ROOT_API + '/auth/login/', params)
      .then((response) => {
        callback(response.data)
      })
      .catch((error) => {
        console.log(error.response)
        errorCallback(error.response.data)
      })
  },
  register (params, callback, errorCallback) {
    axios.post(process.env.ROOT_API + '/auth/registration/', params)
      .then((response) => {
        callback(response.data)
      })
      .catch((error) => {
        errorCallback(error.response.data)
      })
  },
  confirmEmail (params, callback, errorCallback) {
    axios.post(process.env.ROOT_API + '/auth/registration/verify-email/', params)
      .then((response) => {
        callback(response.data)
      })
      .catch((error) => {
        errorCallback(error.response.data)
      })
  },
  resetPassword (params, callback, errorCallback) {
    axios.post(process.env.ROOT_API + '/auth/password/reset/', params)
      .then((response) => {
        callback(response.data)
      })
      .catch((error) => {
        errorCallback(error.response.data)
      })
  },
  confirmResetPassword (params, callback, errorCallback) {
    axios.post(process.env.ROOT_API + '/auth/password/reset/confirm/', params)
      .then((response) => {
        callback(response.data)
      })
      .catch((error) => {
        errorCallback(error.response.data)
      })
  },
  changePassword (params, callback, errorCallback) {
    axios.post(process.env.ROOT_API + '/auth/password/change/', params)
      .then((response) => {
        callback(response.data)
      })
      .catch((error) => {
        errorCallback(error.response.data)
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js